import { PromoCode } from 'common/contracts';
import { Dayjs } from 'dayjs';

export interface ICouponsFormProps {
  edit?: boolean;
  dup?: boolean;
}

export interface CouponFormValues {
  name: string;
  active: boolean;
  discountPercentage: string | number;
  maxRedemptionsPerCustomer: string | number;
  expiredBy: string | null;
  startsAt?: string | null;
  expirationMode?: EExpirationMode;
  firstTimePurchase: boolean;
  supportedOffersBySku: any[];
  promoCodes: PromoCode[];
  allowedPlayers: string[];
}

export interface PromoCodeDetailsData {
  name: string;
  maxRedemptions: number;
  active: boolean;
}

export interface CouponDetailsData {
  name: string;
  active: boolean;
  discountPercentage: number;
  maxRedemptionsPerCustomer: number | null;
  expiredBy: string | null;
  supportedOffersByName: string[];
  supportedOffersByType: string[];
  firstTimePurchase: boolean;
  promoCodes: PromoCodeDetailsData[];
}

export interface UpsertCouponDto {
  name: string;
  active: boolean;
  discountPercentage: number;
  maxRedemptionsPerCustomer?: number | null;
  expiredBy?: string | null;
  startsAt?: string | null;
  supportedOffersBySku?: string[];
  firstTimePurchase: boolean;
  allowedPlayers?: string[];
  id?: string;
}

export interface UpsertPromoCodeDto {
  name: string;
  maxRedemptions: number;
  active: boolean;
  couponId?: string;
  id?: string;
}

export interface UpsertCouponWithPromoCodeDto {
  coupon: UpsertCouponDto;
  promoCodes: UpsertPromoCodeDto[];
}

export enum EExpirationMode {
  PERMANENT = 'permanent',
  TEMPORARY = 'temporary'
}


export interface CouponsOutletContext {
    couponNameValue: string;
    promoCodeValue: string;
    discountValue: string;
    statusValues: string[];
    rangeDates: [Dayjs, Dayjs] | undefined;
    isCouponsEnabled: boolean;
    isCouponsConfigLoading: boolean;
    canUserEdit: boolean;
    canManageCoupons: boolean;
    isDisabledDueToPermissions: boolean;
}
